import React from "react";
//
import { ESortOrder } from "@domains/features/Markets/AIF-PMS/dto/WatchlistDTO";
import Diamond from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Diamond.svg";
import Black from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Black.svg";
import Blue from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Blue.svg";
import Bronze from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Bronze.svg";
import Gold from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Gold.svg";
import Platinum from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Platinum.svg";
import Silver from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Silver.svg";
export var paymentOptions = ["RTGS", "Cheque"];
export var FieldNames = {
    AMCNAME: "AMCNAME",
    FUNDMANAGER: "FUNDMANAGER",
    CATEGORY: "CATEGORY",
    FUND_NAME: "fund name",
    FUND_NAME_CAP: "FUNDNAME",
};
export var FilterSortList = [
    { name: "Name - A to Z", value: "Name", type: ESortOrder.ASCENDING },
    { name: "Name - Z to A", value: "NameDSC", type: ESortOrder.DESCENDING },
    {
        name: "1 Year CAGR Returns - High to Low",
        value: "Year1",
        type: ESortOrder.ASCENDING,
    },
    {
        name: "3 Year CAGR Returns - High to Low",
        value: "Year3",
        type: ESortOrder.ASCENDING,
    },
    {
        name: "5 Year CAGR Returns - High to Low",
        value: "Year5",
        type: ESortOrder.ASCENDING,
    },
    {
        name: "AUM - Highest to Lowest",
        value: "FundSize",
        type: ESortOrder.ASCENDING,
    },
];
export var tabData = [
    {
        eventKey: "261",
        title: "Mutual Fund",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=261",
    },
    {
        eventKey: "268",
        title: "PMS",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=268",
    },
    {
        eventKey: "279",
        title: "ETF",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=279",
    },
    {
        eventKey: "292",
        title: "Structured Products",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=292",
    },
    {
        eventKey: "293",
        title: "AIF",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=293",
    },
    {
        eventKey: "335",
        title: "INVITs",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=335",
    },
    {
        eventKey: "336",
        title: "NFO",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=336",
    },
];
export var filterLabels = [
    {
        title: React.createElement("span", null, "Label 1"),
        disable: false,
        value: "value1",
        keyName: "key1",
        subKeyName: "subKey1",
    },
    {
        title: React.createElement("span", null, "Label 2"),
        disable: true,
        value: 2,
        keyName: "key2",
        subKeyName: "subKey2",
    },
    {
        title: React.createElement("span", null, "Label 3"),
        disable: false,
        value: "value3",
        keyName: "key3",
        subKeyName: "subKey3",
    },
];
export var getClientTierIcon = function (clientTier) {
    var checkClientTier = clientTier === null || clientTier === void 0 ? void 0 : clientTier.toLowerCase();
    switch (checkClientTier) {
        case "diamond":
            return Diamond;
        case "black":
            return Black;
        case "platinum":
            return Platinum;
        case "gold":
            return Gold;
        case "silver":
            return Silver;
        case "bronze":
            return Bronze;
        case "blue":
            return Blue;
        default:
            return "";
    }
};
export var validateOptions = [
    {
        value: "mobile",
        display: "Mobile No.",
    },
    {
        value: "dob",
        display: "Date of Birth",
    },
    {
        value: "email",
        display: "Email",
    },
];
export var MappingSortVal = {
    Name: "name",
    Year1: "year1",
    Year3: "year3",
    Year5: "year5",
    Rating: "rating",
    FundSize: "aum",
    ExpenseRatio: "expenseRatio",
};
export var EFundTabs;
(function (EFundTabs) {
    EFundTabs["EQUITY"] = "equity";
    EFundTabs["HYBRID"] = "hybrid";
    EFundTabs["TAX"] = "tax-saving";
})(EFundTabs || (EFundTabs = {}));
export var FilterSortListBookMark = [
    {
        name: "Name - A to Z",
        value: "display_name-asc",
        type: false,
        filterValue: "display_name",
    },
    {
        name: "Name - Z to A",
        value: "display_name-desc",
        type: true,
        filterValue: "display_name",
    },
    {
        name: "Inception Date - High to Low",
        value: "inception_Date-desc",
        type: true,
        filterValue: "inception_date",
    },
    {
        name: "Inception Date - Low to High",
        value: "inception_Date-asc",
        type: false,
        filterValue: "inception_date",
    },
    {
        name: "Expected Tenure - High to Low",
        value: "tenure-desc",
        type: true,
        filterValue: "tenure",
    },
    {
        name: "Expected Tenure - Low to High",
        value: "tenure-asc",
        type: false,
        filterValue: "tenure",
    },
    {
        name: "Return exp. - High to Low",
        value: "returns_expectations-desc",
        type: true,
        filterValue: "returns_expectations",
    },
    {
        name: "Return exp. - Low to High",
        value: "returns_expectations-asc",
        type: false,
        filterValue: "returns_expectations",
    },
    {
        name: "Benchmark - Highest to Lowest",
        value: "benchmark-desc",
        type: true,
        filterValue: "benchmark",
    },
    {
        name: "Benchmark - Lowest to Highest",
        value: "benchmark-asc",
        type: false,
        filterValue: "benchmark",
    },
];
export var FilterSortListOrderBook = [
    {
        name: "Name - A to Z",
        value: "display_name-asc",
        type: false,
        filterValue: "display_name",
    },
    {
        name: "Name - Z to A",
        value: "display_name-desc",
        type: true,
        filterValue: "display_name",
    },
    {
        name: "Placed on Date - High to Low",
        value: "placed_Date-desc",
        type: false,
        filterValue: "trx_date",
    },
    {
        name: "Placed on Date - Low to High",
        value: "placed_Date-asc",
        type: true,
        filterValue: "trx_date",
    },
    {
        name: "Amount - High to Low",
        value: "placed_Date-desc",
        type: false,
        filterValue: "payment_amt",
    },
    {
        name: "Amount - Low to High",
        value: "placed_Date-asc",
        type: true,
        filterValue: "payment_amt",
    },
];
